/* DE/EU compliance UI: dialogs, cookie settings, withdrawal form (Art. 11a Dir. 2011/83/EU / § 356a BGB). Added 2026-10-04. */
(function () {
  'use strict';
  function $(s, r) { return (r || document).querySelector(s); }
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-lgl-open]');
    if (open) {
      var d = document.getElementById(open.getAttribute('data-lgl-open'));
      if (d && d.showModal) { e.preventDefault(); d.showModal(); }
      return;
    }
    if (e.target.closest('[data-lgl-close]')) { var dd = e.target.closest('dialog'); if (dd) dd.close(); return; }
    var ck = e.target.closest('[data-lgl-cookie]');
    if (ck) {
      e.preventDefault();
      try {
        if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') { window.privacyBanner.showPreferences(); return; }
      } catch (err) { /* fall through */ }
      window.location.href = ck.getAttribute('data-lgl-fallback') || '/policies/privacy-policy';
      return;
    }
    if (e.target.tagName === 'DIALOG' && e.target.classList.contains('lgl-dialog')) {
      var r = e.target.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) e.target.close();
    }
  });
  var form = document.getElementById('lgl-withdraw-form');
  if (!form) return;
  var dlg = document.getElementById('lgl-withdraw');
  var okBox = $('[data-lgl-ok]', dlg), okText = $('[data-lgl-ok-text]', dlg), err = $('[data-lgl-error]', dlg);
  var btn = $('[data-lgl-submit]', form), wrap = $('[data-lgl-w-form-wrap]', dlg), bodyField = $('[data-lgl-body]', form);
  var label = btn ? btn.textContent : '';
  function stamp() {
    var loc = (okBox && okBox.getAttribute('data-locale')) || undefined;
    try { return new Date().toLocaleString(loc, { dateStyle: 'long', timeStyle: 'medium', timeZoneName: 'short' }); }
    catch (x) { return new Date().toString(); }
  }
  form.addEventListener('submit', function (ev) {
    ev.preventDefault();
    if (!form.reportValidity()) return;
    var name = form.elements['contact[name]'].value, email = form.elements['contact[email]'].value;
    var order = form.elements['contact[Bestellnummer / Order]'].value, items = form.elements['contact[Artikel / Items]'].value;
    var when = stamp();
    bodyField.value = 'WIDERRUF / WITHDRAWAL (Art. 11a Richtlinie 2011/83/EU, § 356a BGB)\n' +
      'Erklärung / Declaration: ' + ($('.lgl-declaration', form).textContent) + '\n' +
      'Name: ' + name + '\nE-Mail: ' + email + '\nBestellnummer / Order: ' + order + '\nArtikel / Items: ' + (items || '(gesamte Bestellung / whole order)') + '\n' +
      'Zeitpunkt (Browser) / Time (browser): ' + when + '\nSeite / Page: ' + location.href + '\nSprache / Locale: ' + (document.documentElement.lang || '');
    err.hidden = true; btn.disabled = true; btn.textContent = btn.getAttribute('data-sending') || '…';
    fetch(form.getAttribute('action').split('#')[0], { method: 'POST', body: new FormData(form), credentials: 'same-origin', redirect: 'follow' })
      .then(function (res) {
        if (res.url && res.url.indexOf('/challenge') > -1) { HTMLFormElement.prototype.submit.call(form); return; }
        if (res.ok && (res.redirected || (res.url && res.url.indexOf('contact_posted=true') > -1))) {
          wrap.hidden = true; okBox.hidden = false;
          okText.textContent = (okBox.getAttribute('data-body') || '').replace('{time}', when).replace('{email}', email);
        } else { throw new Error('not posted'); }
      })
      .catch(function () { err.hidden = false; })
      .then(function () { btn.disabled = false; btn.textContent = label; });
  });
})();
